import { MenuBlock, MenuLeaf } from '../../../types/types';

// Depth-first walk returning the first navigable leaf (form or dataset),
// skipping separators and container nodes.
export const getFirstMenuLeaf = (
  items: (MenuBlock | MenuLeaf)[]
): MenuLeaf | undefined => {
  for (const item of items) {
    if ('type' in item && item.type === 'separator') {
      continue;
    }

    if (item.children?.length) {
      const leaf = getFirstMenuLeaf(item.children);
      if (leaf) {
        return leaf;
      }
      continue;
    }

    if (('url' in item && item.url) || ('formId' in item && item.formId)) {
      return item;
    }
  }

  return undefined;
};
